import base from './Base';
import _get from 'lodash/get';

const themeColor = {
  primary: '#77bb1f',
  secondary: '#57585b',

  // used for inner elements-specific to theme
  theme: '#77bb1f',
};

const logo = {
  default: `url(${_get(window.ORGBranding, 'defaultBrand.fleetPlus.logo.white')})`,
  colour: `url(${_get(window.ORGBranding, 'defaultBrand.fleetPlus.logo.colour')})`,
  white: `url(${_get(window.ORGBranding, 'defaultBrand.fleetPlus.logo.white')})`,
  width: 200,
  height: 80,
  left: 32,
  top: 36,
  mobileWidth: 120,
  pageTileMarginTop: 0,
};

const dashboard = {
  driver: '#0b223d',
  vehicle: '#0b223d',
};

const theme = {
  ...base,
  color: { ...base.color, ...themeColor },
  dashboard,
  logo,
};

export default theme;



// WEBPACK FOOTER //
// ./src/themes/themes/FleetPlus.js